import { NSARouterMakerResult, NSAHomePage } from "namirasoft-account-react";
import { SlackSenderLayout } from "../SlackSenderLayout";
import { SlackSenderRouterProps } from "../SlackSenderRouterProps";

export interface HomePageProps extends NSARouterMakerResult, SlackSenderRouterProps { }

export default function HomePage(props: HomePageProps)
{
	return (
		<SlackSenderLayout
			{...props}
		>
			<NSAHomePage
				{...props}
			/>
		</SlackSenderLayout>
	);
}